import React from "react";

/**
 * LogoMarquee - seamlessly scrolling row of logos.
 * logos: [{ name, src }]
 * itemHeight: tailwind class like "h-10" | "h-12" | "h-14"
 */
export const LogoMarquee = ({ logos = [], testIdPrefix = "logo", itemHeight = "h-10" }) => {
  const items = [...logos, ...logos];
  return (
    <div className="marquee-wrap overflow-hidden py-4" data-testid={`${testIdPrefix}-marquee`}>
      <div className="marquee-track flex items-center gap-10">
        {items.map((l, i) => (
          <div
            key={`${l.name}-${i}`}
            className="shrink-0 flex items-center justify-center bg-white rounded-xl border border-slate-200 px-7 py-4 min-w-[200px]"
            data-testid={`${testIdPrefix}-${i}`}
            title={l.name}
          >
            <img
              src={l.src}
              alt={l.name}
              className={`${itemHeight} w-auto object-contain`}
              loading="lazy"
              onError={(e) => {
                e.currentTarget.outerHTML = `<span class="text-sm font-semibold text-slate-700 whitespace-nowrap">${l.name}</span>`;
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
